// src/pages/AboutUsPage.js
import React from 'react';
import { Link } from 'react-router-dom';
import AboutUs from '../components/AboutUs';
import './AboutUsPage.css';

const AboutUsPage = () => {
  return (
    <div className="about-page">
      <header className="about-page-header">
        <div className="about-page-header-content">
          <Link to="/" className="about-page-back-btn">
            <svg
              width="16"
              height="16"
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
              strokeWidth="2.5"
              strokeLinecap="round"
              strokeLinejoin="round"
            >
              <line x1="19" y1="12" x2="5" y2="12" />
              <polyline points="12 19 5 12 12 5" />
            </svg>
            Back to Home
          </Link>

          <h1 className="about-page-title">About Us</h1>
          <p className="about-page-subtitle">
            Learn more about QSlot — your all-in-one booking platform.
          </p>
        </div>
      </header>

      <main>
        <AboutUs />
      </main>
    </div>
  );
};

export default AboutUsPage;